import React, { FC } from 'react';
import { Link as MuiLink, Typography, useMediaQuery, useTheme } from '@mui/material';
import { Link as ReactRouterDomLink, useNavigate } from 'react-router-dom';
import Button from '../Button';

interface LinkProps {
  href: string;
  hrefText: string;
  hrefRelative?: boolean;
}

const Link: FC<LinkProps> = ({ href, hrefText, hrefRelative = false }) => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'));
  const navigate = useNavigate();

  return (
    (!isTablet ?
      (
        (hrefRelative ?
          (
            <ReactRouterDomLink
              style={{
                color: '#E20B23',
                fontSize: 16,
                fontWeight: 500,
                textDecoration: 'none',
                width: 'fit-content'
              }}
              to={href}>
              <Typography variant='secondaryFont'>{hrefText}</Typography>
            </ReactRouterDomLink>
          )
          :
          (
            <MuiLink
              sx={{
                color: '#E20B23',
                fontSize: 16,
                fontWeight: 500,
                textDecoration: 'none'
              }}
              href={href}
              target="_blank" rel="noreferrer">
              <Typography variant='secondaryFont'>{hrefText}</Typography>
            </MuiLink>
          )
        )
      )
      :
      (
        <Button onClick={() => hrefRelative
          ? navigate(href)
          : window.open(href, '_blank')}>
          <Typography variant='secondaryFont'>{hrefText}</Typography>
        </Button>
      )
    )
  )
};

export default Link;
